import {transparentize} from 'polished';
import styled, {css} from 'styled-components';

import {colors, buttonReset} from '@app/styles/theme';

export const ButtonRoot = styled.button<{hoverIndication?: boolean}>`
    ${buttonReset};

    // main style
    padding: 10px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    ${(p) =>
        p.hoverIndication &&
        css`
            &:not(:disabled):hover {
                background-color: ${transparentize(0.9, colors.brandPrimary)};
            }

            &:not(:disabled):active {
                background-color: ${transparentize(0.85, colors.brandPrimary)};
            }
        `}

    &:focus:not(.focus-visible) {
        outline: none;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const ButtonInner = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;
